module.exports = __webpack_public_path__ + "static/media/Trash.5f0223ba.svg";